import { createSlice } from "@reduxjs/toolkit";

import {
  addDisbursementsAction,
  approveDisbursementAction,
  editDisbursementsAction,
  getDisbursementsListAction,
  getSharedDisbursementsListAction,
  getSingleDisbursementAction,
} from "@/redux/disbursements/actions";
import type { DisbursementsType } from "@/redux/disbursements/disbursementsType";
import { initialState } from "@/redux/disbursements/initialState";
import { disbursementsReducer } from "@/redux/disbursements/reducer";

export const disbursementsSlice = createSlice({
  name: "disbursementss",
  initialState,
  reducers: disbursementsReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getDisbursementsListAction.pending,
      (state: DisbursementsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getDisbursementsListAction.fulfilled,
      (state: DisbursementsType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          disbursementsList: result?.data,
          totalCount: result?.total_count,
          totalAmount: result?.total_amount,
          remainingAmount: result?.remaining_amount,
        };
      }
    );

    builder.addCase(
      getDisbursementsListAction.rejected,
      (state: DisbursementsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getSharedDisbursementsListAction.pending,
      (state: DisbursementsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSharedDisbursementsListAction.fulfilled,
      (state: DisbursementsType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          sharedDisbursementList: result?.data,
          totalSharedCount: result?.total_count,
          totalAmount: result?.total_amount,
          remainingAmount: result?.remaining_amount,
        };
      }
    );

    builder.addCase(
      getSharedDisbursementsListAction.rejected,
      (state: DisbursementsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getSingleDisbursementAction.pending,
      (state: DisbursementsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleDisbursementAction.fulfilled,
      (state: DisbursementsType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          singleDisbursement: result,
        };
      }
    );

    builder.addCase(
      getSingleDisbursementAction.rejected,
      (state: DisbursementsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      editDisbursementsAction.pending,
      (state: DisbursementsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      editDisbursementsAction.fulfilled,
      (state: DisbursementsType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
        };
      }
    );

    builder.addCase(
      editDisbursementsAction.rejected,
      (state: DisbursementsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      addDisbursementsAction.pending,
      (state: DisbursementsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addDisbursementsAction.fulfilled,
      (state: DisbursementsType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
        };
      }
    );

    builder.addCase(
      addDisbursementsAction.rejected,
      (state: DisbursementsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      approveDisbursementAction.pending,
      (state: DisbursementsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      approveDisbursementAction.fulfilled,
      (state: DisbursementsType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          approvalMessage: message,
          approvalSuccess: success,
        };
      }
    );

    builder.addCase(
      approveDisbursementAction.rejected,
      (state: DisbursementsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );
  },
});
export const {
  resetDisbursementsSuccess,
  resetDisbursementsError,
  resetDisbursementsMessage,
  resetDisbursementsStatusCode,
  resetDisbursementList,
  resetSingleDisbursement,
  resetApprovalMessage,
  resetApprovalSuccess,
  resetTotalCount,
  resetSharedDisbursementList,
  resetTotalSharedCount,
  resetDisbursmentFetching,
  resetTotalAmount,
  resetRemainingAmount,
} = disbursementsSlice.actions;
